<template>
  <v-container>
    <h1 class="text-center">STORE ITEM DETIALS UPDATE</h1>
    <div>
      <v-form ref="form">
        <v-container>
          <template>
            <span class="red--text">*leave both the column blank if there is no stock</span>
            <v-simple-table height="300px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">ITEM NAME</th>
                    <th class="text-left">CATEGORY</th>
                    <th class="text-left">MRP</th>
                    <th class="text-left">STOCK</th>
                    <th class="text-left">BOUGHT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in VENDOR_PRODUCTS" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.category }}</td>
                    <td>
                      <v-text-field label="MRP  ₹" required v-model="item.newStockRate"></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="Qty" required v-model="item.newStock"></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="BOUGHT RATE TOTAL ₹" required v-model="item.bought_rate"></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-container>
      </v-form>
      <v-btn color="primary1" block dark @click="addStock">UPDATE</v-btn>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      invoiceNumber: "",
      invoiceRate: "",
      indate: "",
      selDate: "",
      menu: false,
    };
  },
  activated() {
    this.$store.commit("SET_LOADING", true);
    this.GET_PRODUCT_LIST({ id: this.$route.params.id }).then(() => {
      this.$store.commit("SET_LOADING", false);
    });
  },
  computed: {
    ...mapGetters(["RULES", "VENDOR_PRODUCTS", "STOCKROOM"]),
  },
  methods: {
    ...mapActions(["GET_PRODUCT_LIST", "UPDATE_STOCK_ITEMS_UPDATE"]),
    addStock() {
      let prodList = [];
      this.VENDOR_PRODUCTS.forEach((el) => {
        if (
          el.newStockRate != "" &&
          el.newStockRate != undefined &&
          el.newStock != "" &&
          el.newStock != undefined &&
          el.bought_rate != "" &&
          el.bought_rate != undefined
        ) {
          prodList.push({
            pid: el.id,
            mrp: el.newStockRate,
            stock: el.newStock,
            rate: el.newStockRate,
            bought_rate: el.bought_rate,
          });
        }
      });
      if (prodList.length >= 1) {
        this.$store.commit("SET_LOADING", true);
        this.UPDATE_STOCK_ITEMS_UPDATE({
          id: this.$route.params.uid,
          prodList,
        }).then(() => {
          this.$router.replace({
            name: "STOREROOMSTOCK",
            params: {
              id: this.$route.params.uid,
            },
          });
          this.$store.commit("SET_LOADING", false);
        });
      } else {
        this.$store.commit("SET_INFO", "No Stock Added");
      }
    },
  },
  watch: {},
};
</script>

<style>
</style>